<template>
    <div class="calendar booking-calendar">
        <calendar-body :employee="employee" @input="emitEvent" v-model="selected"></calendar-body>
        <footer class="calendar-footer">
            <button class="button is-small" :class="{ 'is-dark': ! selected, 'is-primary': selected }" :disabled="! selected" v-text="lang('Seleziona Giorno')"></button>
        </footer>
    </div>
</template>
<script>
    import moment from 'moment'

    export default {
        props: {
            date: {
                type: String,
                required: false,
                default: ''
            },
            employee: {
                type: Object,
                required: true
            },
            value: {
                required: true,
                type: Object
            }
        },
        created() {
            this.selected = this.value;
        },
        data() {
            return {
                selected: false
            }
        },
        methods: {
            emitEvent() {
                this.$emit('input', this.selected)
            }
        },
        watch: {
            value( date ) {
                if( moment.isMoment( date ) ) this.selected = date
            }
        }
    }
</script>